import { render, staticRenderFns } from "./PublicationsTable.vue?vue&type=template&id=5c9f02d2&scoped=true&"
import script from "./PublicationsTable.vue?vue&type=script&lang=js&"
export * from "./PublicationsTable.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsTable.vue?vue&type=style&index=0&id=5c9f02d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9f02d2",
  null
  
)

export default component.exports